<template>
    <div id="loopVertical">
        <div id="verticalTital">三博产品</div>
        <div id="verticalContainer">
            <!-- 撑开div -->
            <div id="itemSeat"></div>
            <!-- 内容 -->
            <div id="itemCont">
                <el-carousel direction="vertical" height="100%" :autoplay="false">
                    <el-carousel-item>
                        <div class="verticalItem">
                            <div class="itemImg">
                                <img src="../../assets/imgs/home/ver1.png">
                            </div>
                            <div class="itemText">
                                <div class="textTital">
                                    <p>智慧水务：为水务安装智慧大脑</p>
                                    <span></span>
                                </div>
                                <div class="textCont">
                                    智慧水务是指通过数据采集、传输等传感设备实时感知城市供排水系统的运行状态，采用可视化方式有机整合了水务管理部门与供排水设施，形成“水务物联网”，利用数据建模分析海量的给排水数据，构建一个基于物联网的给排水综合智慧平台，实现最佳管理状态，提升运营效益。
                                </div>
                                <div class="itemLink">
                                    <router-link to="/product?id=0" tag="button">查看详情</router-link>
                                    <router-link to="/" tag="span"><span></span>更多产品</router-link>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                    <!-- 第二页 -->
                    <el-carousel-item>
                        <div class="verticalItem">
                            <div class="itemImg">
                                <img src="../../assets/imgs/home/ver2.png">
                            </div>
                            <div class="itemText">
                                <div class="textTital">
                                    <p>智慧水务：实时水力模型（B/S）系统</p>
                                    <span></span>
                                </div>
                                <div class="textCont">
                                   供水管网实时水力模型（B/S）系统是集中整合供水管网运行工况信息的平台，是对供水管网运行工况进行实时数字模拟的平台，更是通过数据挖掘、智能算法、深度学习、水力分析等方法实现供水管网管理信息化向智能化转变的平台。
                                </div>
                                <div class="itemLink">
                                    <router-link to="/product?id=0" tag="button">查看详情</router-link>
                                    <router-link to="/" tag="span"><span></span>更多产品</router-link>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                    <!-- 第三页 -->
                     <el-carousel-item>
                        <div class="verticalItem">
                            <div class="itemImg">
                                <img src="../../assets/imgs/home/ver3.png">
                            </div>
                            <div class="itemText">
                                <div class="textTital">
                                    <p>智慧水务系统：产销差计算分析系统</p>
                                    <span></span>
                                </div>
                                <div class="textCont">
                                    产销差计算分析产销差计算分析系统是建立各级别分区漏水实时监测和预警，并实现对各区域的在线漏损指标分析计算和汇总供水范围内各级产销差，从而使水司能够有效控制供水管网的产销差率，更加科学地管理产销差的操作过程。
                                </div>
                                <div class="itemLink">
                                    <router-link to="/product?id=0" tag="button">查看详情</router-link>
                                    <router-link to="/" tag="span"><span></span>更多产品</router-link>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Screen2',
}
</script>

<style scoped>
    #loopVertical{
        margin-top:1.5625%;
        margin-left:12.5%;
        margin-bottom: 3.90625%;
        margin-right:5.98958333%;
    }
    #verticalTital{
        line-height: 60px;
        text-align: right;
        border-right: 11px solid #086bc4;
        padding-right: 40px;
        font-size: 30px;
        margin-right: 5px;
        font-weight: bold;
    }
    #verticalContainer{
        position: relative;
    }
    #itemSeat{
        width:100%;
        height:0;
        overflow:hidden;
        /* padding-bottom:42.173%; */
        padding-bottom:36%;
    }
    #itemCont{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
    .el-carousel--vertical{
        width: 100%;
        height: 100%;
    }
    .itemImg{
        width: 38.338658%;
        left:0;
        bottom: 0;
        position: absolute;
    }
    .itemImg>img{
        width: 100%;
    }
    .itemText{
        width: 49.84%;
        right:0;
        bottom: 0;
        position: absolute;
        height: 85%;
    }
    .itemLink{
        position: absolute;
        bottom: 15px;
        width: 100%;
        display: flex;
        align-items: Center;
    }
    .itemLink button{
        border: 0;
        color: #fff;
        background: #086bc4;
        font-size: 16px;
        padding: 11px 20px;
        cursor: pointer;
    }
    .itemLink>span{
        position: absolute;
        right:0;
        font-size: 16px;
    }
    .itemLink>span>span{
        display: inline-block;
        width: 90px;
        height: 3px;
        background: #333;
        margin-right: 10px;
        margin-bottom: 4px;
    }
    .textCont{
        width: 79.48718%;
        text-indent:32px;
        line-height: 32px;
        font-size: 16px;
    }
    .textTital{
        width: 79.48718%;
    }
    .textTital>p{
        font-size: 28px;
        font-weight: bold;
    }
    .textTital>span{
            width: 112px;
            height: 5px;
            display: inline-block;
            margin-top: 40px;
            margin-bottom: 30px;
            background: #000;
    }
    @media screen and (max-width: 1540px) {
        .textTital>p{
            font-size: 26.5px;
        }
        .textTital>span{
            margin-top: 30px;
             margin-bottom: 20px;
        }
        .textCont {
            text-indent: 30px;
            line-height: 30px;
            font-size: 15px;
        }
        .itemLink button{
            font-size: 15px;
            padding: 10.5px 20px;
        }
        .itemLink>span{
            font-size: 15px;
        }
    }
    @media screen and (max-width: 1450px) {
        .textTital>p{
            font-size: 25px;
        }
        .textTital>span{
            margin-top: 20px;
            margin-bottom: 15px;
        }
        .textCont {
            text-indent: 28px;
            line-height: 22px;
            font-size: 14px;
        }
        .itemLink button{
            font-size: 14px;
            padding: 8px 20px;
        }
        .itemLink>span{
            font-size: 14px;
        }
    }
</style>
